






























import Vue from "vue";
import { GetChangeDetailResponse } from "@/containers/changePlansSb/api";
import { defaultChangePlansData } from "@/components/AboutChangePlansSb/props";

type Props = {
  lang: any;
  changePlansData: GetChangeDetailResponse;
};
type Data = {};
type Method = {};
type Computed = {};

export default Vue.extend<Data, Method, Computed, Props>({
  props: {
    lang: { default: () => {} },
    changePlansData: {
      default: () => defaultChangePlansData
    }
  }
});
